<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Subir Tomografias </h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">/ Inicio / Subir Tomografia</span>
  </div>
</div>

</div>


<div class="row row-sm">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="mb-3">
          <label for="formFileSm" class="form-label">Seleccione el archivo .zip</label>
          <input class="form-control" #fileInput accept=".zip" type="file" (change)="onFileSelected($event)">
        </div>
        <div class="mb-3">
          <button class="btn btn-primary" [disabled]="isUploading" (click)="onUploadFile()">Subir Archivo</button>
        </div>

        @if (uploadInProgress) {
          <div>
            <div class="progress">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                [style.width]="progress + '%'"
                [attr.aria-valuenow]="progress"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div>{{ progress }}% Subiendo...</div>
          </div>
        }
        @if (textInput != '') {
          <div class="input-group">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary" type="button" (click)="copyText()">Copiar</button>
            </div>
            <input type="text" class="form-control" readonly [(ngModel)]="textInput" id="textInput" placeholder="Escriba algo aquí">
          </div>
          <label for="" class="mt-1 text-success">{{labelText}}</label>
        }


      </div>
    </div>
  </div>